import { useState } from "react";
import { useTranslation } from "react-i18next";
import HelpArticlePanel from "src/common/components/HelpArticleSection/HelpArticlePanel";
import { useHelpArticle } from "src/common/components/HelpArticleSection/useHelpArticle";

export const MEDIA_UPLOAD_HELP_KEY = "help_media_upload";

export const useMediaUploadHelp = () => {
  const { t } = useTranslation();
  const { status, article } = useHelpArticle(MEDIA_UPLOAD_HELP_KEY);
  const [open, setOpen] = useState(false);
  return {
    ready: status === "ready",
    article,
    open,
    setOpen,
    title: t("pages.gallery.uploadHelp.title"),
    learnMore: t("pages.gallery.uploadHelp.learnMore"),
  };
};

export const MediaUploadHelpLink = ({ className = "text-green-500" }: { className?: string }) => {
  const help = useMediaUploadHelp();
  if (!help.ready) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => help.setOpen(true)}
        className={`font-bold underline underline-offset-4 ${className}`}
      >
        {help.learnMore}
      </button>
      <HelpArticlePanel
        title={help.title}
        article={help.article}
        open={help.open}
        onClose={() => help.setOpen(false)}
      />
    </>
  );
};
